import { AnimatePresence, motion } from "framer-motion";

import { Laptop, ChevronDown, GraduationCap, Briefcase } from "lucide-react";

import DataFetcherTemplateHome2 from "../../hooks/DataFetcherTemplate2";
import BlockImageCabecera from "../../components/BlockImageCabecera";

import DescuentosEnlinea from "./DescuentosEnlinea";
import Accordion from "../../components/Accordion";
import DescuentosTecnologias from "./DescuentosTecnologias";

import DescuentosPosgrados from "./DescuentosPosgrados";

const url =
  "https://portales.utpl.edu.ec/beportales/jsonapi/node/template_home/1cb1a54a-1c6a-429c-b71d-458fe06bf554" +
  "?include=field_imagen_portada.field_media_image,field_imagen13.field_media_image," +
  "field_gallery.field_media_image,field_gallery1.field_media_image," +
  "field_imagen5.field_media_image," +
  "field_imagen6.field_media_image," +
  "field_imagen14.field_media_image,field_imagen15.field_media_image" +
  "&fields[node--template_home]=title,field_imagen_portada,field_texto_portada,field_bloque1,field_bloque2,field_bloque3,field_bloque4,field_bloque5,field_bloque6,field_bloque7,field_bloque8,field_bloque9,field_bloque10,field_bloque11,field_bloque12,field_bloque13,field_bloque14,field_bloque15," +
  "field_gallery,field_gallery1,field_bloque16,field_bloque17,field_bloque18,field_bloque19,field_bloque20,field_bloque21,field_bloque22,field_bloque23,field_bloque24,field_bloque25,field_bloque26,field_bloque27,field_bloque28,field_bloque29,field_bloque30," +
  "field_imagen5,field_imagen6,field_imagen13,field_imagen14,field_imagen15" +
  "&fields[media--image]=field_media_image";

export default function Matriculas() {
  const DataDisplay = ({ data }) => (
    <div>
      <BlockImageCabecera
        src={data.imagen_portada}
        title={
          <div
            dangerouslySetInnerHTML={{
              __html: data.texto_portada,
            }}
          />
        }
      />

      <div className="bg-[#004270] py-10">
        <div className="max-w-6xl mx-auto ">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* CARD 1 */}
            <a
              href="#enlinea"
              className="group relative flex flex-col items-center text-center 
      bg-white border border-gray-200 
      rounded-2xl p-6 
      shadow-sm hover:shadow-xl 
      transition-all duration-300 hover:-translate-y-2"
            >
              {/* ICONO */}
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl 
      bg-blue-50 text-blue-600 mb-4 
      transition-all duration-300 group-hover:scale-110"
              >
                <Laptop className="w-7 h-7" />
              </div>

              {/* TEXTO */}
              <h4>Carreras a distancia y en línea, carreras tecnológicas</h4>

              {/* FLECHA */}
              <motion.div
                className="absolute bottom-3"
                animate={{ y: [0, 6, 0] }}
                transition={{ duration: 1.2, repeat: Infinity }}
              >
                <ChevronDown className="w-6 h-6 text-gray-400 group-hover:text-gray-700" />
              </motion.div>
            </a>

            {/* CARD 2 */}
            <a
              href="#presencial"
              className="group relative flex flex-col items-center text-center 
      bg-white border border-gray-200 
      rounded-2xl p-6 
      shadow-sm hover:shadow-xl 
      transition-all duration-300 hover:-translate-y-2"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl 
      bg-yellow-50 text-yellow-600 mb-4 
      transition-all duration-300 group-hover:scale-110"
              >
                <GraduationCap className="w-7 h-7" />
              </div>

              <h4>Carreras presencial</h4>

              <motion.div
                className="absolute bottom-3"
                animate={{ y: [0, 6, 0] }}
                transition={{ duration: 1.2, repeat: Infinity }}
              >
                <ChevronDown className="w-6 h-6 text-gray-400 group-hover:text-gray-700" />
              </motion.div>
            </a>

            {/* CARD 3 */}
            <a
              href="#posgrados"
              className="group relative flex flex-col items-center text-center 
      bg-white border border-gray-200 
      rounded-2xl p-6 
      shadow-sm hover:shadow-xl 
      transition-all duration-300 hover:-translate-y-2"
            >
              <div
                className="w-14 h-14 flex items-center justify-center rounded-xl 
      bg-indigo-50 text-indigo-600 mb-4 
      transition-all duration-300 group-hover:scale-110"
              >
                <Briefcase className="w-7 h-7" />
              </div>

              <h4>Posgrados</h4>

              <motion.div
                className="absolute bottom-3"
                animate={{ y: [0, 6, 0] }}
                transition={{ duration: 1.2, repeat: Infinity }}
              >
                <ChevronDown className="w-6 h-6 text-gray-400 group-hover:text-gray-700" />
              </motion.div>
            </a>
          </div>
        </div>
      </div>

      {/*Modalidad a distancia y en línea, carreras tecnológicas */}
      {data.bloque2 && (
        <section id="enlinea" className=" link-with-arrow-1">
          <div className="max-w-6xl m-auto px-6 py-24">
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque2,
              }}
            />

            <div className="mt-4">
              <Accordion
                title="Fechas de matrícula para carreras a distancia y en línea"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque3,
                    }}
                  />
                }
              ></Accordion>

              <Accordion
                title="Descuentos para carreras a distancia y en línea"
                content={<DescuentosEnlinea></DescuentosEnlinea>}
              ></Accordion>
              <Accordion
                title="Fechas de matrícula para carreras tecnológicas"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque4,
                    }}
                  />
                }
              ></Accordion>
              <Accordion
                title="Descuentos para carreras tecnológicas"
                content={<DescuentosTecnologias />}
              ></Accordion>

              <Accordion
                title="Calendario académico"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque5,
                    }}
                  />
                }
              ></Accordion>
            </div>
          </div>
        </section>
      )}

      {/*Carreras presencial */}
      {data.bloque6 && (
        <section id="presencial" className=" bg-slate-50 link-with-arrow-1">
          <div className="max-w-6xl m-auto px-6 py-24">
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque6,
              }}
            />

            <div className="mt-4">
              <Accordion
                title="Fechas de matrícula "
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque7,
                    }}
                  />
                }
              ></Accordion>

              <Accordion
                title="Calendario académico"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque8,
                    }}
                  />
                }
              ></Accordion>
            </div>
          </div>
        </section>
      )}

      {/*Posgrados */}
      {data.bloque9 && (
        <section id="posgrados" className=" link-with-arrow-1">
          <div className="max-w-6xl m-auto px-6 py-24">
            <div
              dangerouslySetInnerHTML={{
                __html: data.bloque9,
              }}
            />

            <div className="mt-4">
              <Accordion
                title="Fechas de matrícula"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque10,
                    }}
                  />
                }
              ></Accordion>

              <Accordion
                title="Descuentos"
                content={<DescuentosPosgrados />}
              ></Accordion>

              <Accordion
                title="Calendario académico"
                content={
                  <div
                    dangerouslySetInnerHTML={{
                      __html: data.bloque11,
                    }}
                  />
                }
              ></Accordion>
            </div>
          </div>
        </section>
      )}
    </div>
  );

  return (
    <DataFetcherTemplateHome2 url={url}>
      {(data) => (
        <AnimatePresence mode="wait">
          <DataDisplay key="data-loaded" data={data} />
        </AnimatePresence>
      )}
    </DataFetcherTemplateHome2>
  );
}
